import { PopoverContent } from "@material-tailwind/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { APP_NAME } from "../../utils/appConstant";
function TermsOfUsePopover({ setIsPopoverOpen }: any) {
  // const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <PopoverContent className="outline-none relative z-50 w-5/12 h-2/5 overflow-auto min-w-60">
      <button
        onClick={() => setIsPopoverOpen(false)}
        aria-label="Close"
        className="absolute top-2 right-2 z-10 bg-white rounded-full p-2 hover:bg-gray-100"
      >
        <XMarkIcon className="w-6 h-6 text-gray-700 hover:text-gray-500" />
      </button>
      {/* Terms of Use */}
      <div className="h-[calc(100%-20px)] overflow-y-auto px-4 pt-2 pb-4">
        <div>
          <h1 className="font-bold">Terms of Use</h1>

          <div className="mx-6 text-sm list-decimal ">
            <div className="list-item m-2">
              <div>
                Welcome to {APP_NAME}, a proprietary online tool developed by PM Power Consulting Private Limited (PMPC). By registering for
                and using &nbsp;
                {APP_NAME}, the user agrees to comply with these Terms of Use. Please read them carefully.
              </div>
            </div>
            <div className="list-item m-2">
              <div>
                PMPC is a registered company under the Indian Companies Act. Since 2006, PMPC offers contextualized transformative solutions
                that forge impactful leaders and build adaptive & resilient delivery organizations. For more details visit{" "}
                <a href="http://www.pm-powerconsulting.com" target="_blank" className="text-blue-500 outline-none">
                  www.pm-powerconsulting.com
                </a>
                .
              </div>
            </div>
          </div>
        </div>
        {/* About PowerGuide */}

        <div className="">
          <h1 className="font-bold ">About {APP_NAME}</h1>

          <div className="mx-6 list-decimal ">
            <div className="list-item m-2">
              <div>
                {APP_NAME} is PMPC&#39;s proprietary online tool designed to provide exclusive access to PMPC’s knowledge base accumulated
                through years of experience.
              </div>
            </div>
            <div className="list-item m-2">
              <div>
                {APP_NAME} responds to user’s queries and offers guidance in PMPC’s areas of expertise. Access to {APP_NAME} is provided
                only to a specific set of users through a formal offer-and-acceptance process.
              </div>
            </div>
          </div>
        </div>
        {/* Proprietary Rights */}

        <div className="">
          <h1 className="font-bold">Proprietary Rights</h1>

          <div className="mx-6 list-decimal ">
            <div className="list-item m-2">
              <span className="font-bold ">Ownership:</span> {APP_NAME} is the exclusive property of PMPC, which includes all Intellectual
              Property Rights (IPR).
            </div>
            <div className="list-item m-2">
              <span className="font-bold ">Protection of Rights:</span> PMPC retains the absolute right to take legal action to protect
              against:
            </div>
            <ul className=" mx-12 list-disc">
              <li>
                <p>Infringement, unauthorized use, passing off, or dilution of {APP_NAME}.</p>
              </li>
              <li>
                {" "}
                <p>Any activity jeopardizing the safety, security, or integrity of {APP_NAME}.</p>
              </li>
            </ul>

            <div className="list-item m-2">
              <span className="font-bold ">Use of Content:</span> Users are prohibited from copying, modifying, or redistributing {APP_NAME}{" "}
              content without explicit written permission from PMPC.
            </div>
          </div>
        </div>
        {/* Privacy Statement */}

        <div className="">
          <h1 className="font-bold">Privacy Statement</h1>

          <div className="mx-6 list-decimal">
            <span className="list-item m-2">
              {" "}
              <span className="font-bold">Confidentiality:</span>
            </span>
            <ul className=" mx-12 list-disc">
              <li>
                <p>All queries and responses generated for the user are private and visible only to the users.</p>
              </li>
              <li>
                {" "}
                <p>Personal data provided during registration is used solely to manage access and improve responses.</p>
              </li>
            </ul>
            <span className="list-item m-2 ">
              {" "}
              <span className="font-bold">Security:</span>
            </span>
            <ul className=" mx-12 list-disc">
              <li>
                <p>PMPC uses encryption and access controls to safeguard the user’s data from unauthorized access.</p>
              </li>
              <li>
                {" "}
                <p>
                  PMPC may gather data to analyse patterns and improve functionality. This information cannot be traced back to individual
                  users. PMPC may use data to contextualize interactions and improve {APP_NAME}&#39;s functionality.
                </p>
              </li>
            </ul>
            <span className="list-item  m-2">
              {" "}
              <span className="font-bold">Exceptions:</span>
            </span>
            <ul className=" mx-12 list-disc">
              <li>
                <p>
                  Queries and responses may be reviewed by PMPC teams for quality improvements. But such queries and responses will be
                  anonymous and PMPC or its affiliates won’t be able to trace such data back to the users.
                </p>
              </li>
              <li>
                {" "}
                <p>
                  Data may be shared with Courts and/or Governmental Authorities to comply with legal obligations, prevent illegal
                  activities, or ensure product integrity and security.
                </p>
              </li>
            </ul>
          </div>
        </div>
        {/* Client Responsibilities */}

        <div className="">
          <h1 className="mt-2 font-bold">Client Responsibilities</h1>

          <div className="mx-6 list-decimal ">
            <p className="  list-item m-2">
              <span className=" font-bold">Eligibility:</span>
              <span className="font-normal">
                {" "}
                User must be 18 years or older and provide correct information to register and use {APP_NAME}.
              </span>
            </p>
            <p className=" m-2 list-item">
              <span className=" font-bold ">Permitted Use:</span>
              <span className="font-normal"> {APP_NAME} may be used solely for learning and professional guidance.</span>
            </p>
            <p className=" m-2 list-item">
              <span className=" font-bold ">Prohibited Use:</span>
              <span className="font-normal"> Users may not:</span>
            </p>
            <ul className=" mx-12 list-disc">
              <li>
                <p>Violate laws or regulations while using {APP_NAME}.</p>
              </li>
              <li>
                {" "}
                <p>Copy, modify, or distribute {APP_NAME} content without approval.</p>
              </li>
              <li>
                {" "}
                <p>Use automated systems to extract data or claim responses as human-generated. approval.</p>
              </li>
            </ul>
            <p className=" m-2 list-item">
              <span className=" font-bold ">Prohibited Use:</span>
              {/* <span className="font-normal"> Users may not:</span> */}
            </p>
            <ul className=" mx-12 list-decimal">
              <li>
                <p>PMPC reserves the right to suspend or terminate your account if:</p>
                <ul className="mx-8 list-disc">
                  <li>
                    <p>User breaches these terms.</p>
                  </li>
                  <li>
                    <p>Required by law.</p>
                  </li>
                  <li>
                    <p>The user’s usage poses a risk to {APP_NAME}, its other users, or PMPC&#39;s rights.</p>
                  </li>
                </ul>
              </li>
              <li>
                {" "}
                <p>Users may discontinue using {APP_NAME} at any time.</p>
              </li>
            </ul>
          </div>
        </div>
        {/* Termination of Use */}

        <div className="">
          <h1 className="mt-2 font-bold">Termination of Use</h1>

          <div className="mx-6 list-decimal ">
            <ul className="m-2 list-decimal">
              <li>
                <p>PMPC reserves the right to suspend or terminate your account if:</p>
                <ul className="mx-8 list-disc">
                  <li>
                    <p>User breaches these terms.</p>
                  </li>
                  <li>
                    <p>Required by law.</p>
                  </li>
                  <li>
                    <p>The user’s usage poses a risk to {APP_NAME}, its other users, or PMPC&#39;s rights.</p>
                  </li>
                </ul>
              </li>
              <li>
                {" "}
                <p>Users may discontinue using {APP_NAME} at any time.</p>
              </li>
            </ul>
          </div>
        </div>
        {/* Discontinuation of PowerGuide */}

        <div className="">
          <h1 className="font-bold">Discontinuation of {APP_NAME}</h1>

          <div className="mx-6 m-2 list-decimal ">
            <p className="">
              If PMPC decides to discontinue {APP_NAME}, advance notice will be provided. Any prepaid, unused services will be refunded.
            </p>
          </div>
        </div>
        {/* Limitation of Liability */}

        <div className="">
          <h1 className="font-bold">Limitation of Liability</h1>

          <div className="mx-6 list-decimal ">
            <ul className="  m-2 list-decimal">
              <li>
                <p>
                  PMPC and its affiliates are not responsible for indirect, incidental, or consequential damages, including loss of profits.
                </p>
              </li>
              <li>
                {" "}
                <p>Users must evaluate {APP_NAME}’s responses for relevance and accuracy and are responsible for its implementation.</p>
              </li>
              <li>
                {" "}
                <p>
                  PMPC’s aggregate liability is limited to the amount paid by the user for {APP_NAME} services in the 12 months preceding
                  the claim.
                </p>
              </li>
            </ul>
          </div>
        </div>
        {/* Governing Laws and Jurisdiction */}

        <div className="">
          <h1 className="font-bold">Governing Laws and Jurisdiction</h1>

          <div className="mx-6 list-decimal ">
            {/* <span className="list-item font-bold ">Confidentiality:</span> */}
            <ul className=" m-2 list-decimal">
              <li>
                <p>These terms are governed exclusively by the laws of India.</p>
              </li>
              <li>
                {" "}
                <p>Any disputes will be subject to the jurisdiction of courts in Bangalore, India.</p>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <p className="font-bold">
            By using {APP_NAME}, the users acknowledge that the user has read, understood, and agreed to these Terms of Use and Privacy
            Policy. For any further queries, please contact <span className="text-blue-600">info@pm- powerconsulting.com</span>.
          </p>
        </div>
      </div>
    </PopoverContent>
  );
}

export default TermsOfUsePopover;
